import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return <>{children}</>;
}